import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3705cfd0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "up-candle"
};
const _hoisted_3 = {
  class: "down-candle"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Spend", -1));
const _hoisted_6 = {
  class: "value"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "period-string"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  return _openBlock(), _createElementBlock("div", {
    class: "spend-evolution-candle",
    id: `${$data.uid}_candle`,
    onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.onHovering && $options.onHovering(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.onLeaving && $options.onLeaving(...args))
  }, [_createElementVNode("div", _hoisted_2, [$props.data.evol_value >= 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      height: $options.height
    }),
    class: _normalizeClass(["candle", {
      hovering: $options.isHovering
    }])
  }, null, 6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [$props.data.evol_value < 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      height: $options.height
    }),
    class: _normalizeClass(["candle", {
      hovering: $options.isHovering
    }])
  }, null, 6)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "tooltip-hover",
    style: _normalizeStyle({
      display: $props.hovering_index == $props.index && $props.hovering_workspace_id == $props.workspace_id && $props.hovering_seller_id == $props.seller_id ? 'flex' : 'none'
    })
  }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_currency_value, {
    value: $props.data.kpi_value,
    precision: "0"
  }, null, 8, ["value"]), _createElementVNode("div", _hoisted_7, _toDisplayString($props.data.evol_value < 0 ? `${($props.data.evol_value * 100).toFixed(0)}%` : `+${($props.data.evol_value * 100).toFixed(0)}%`), 1)])]), _createElementVNode("div", _hoisted_8, _toDisplayString($props.data.label), 1)], 4)], 40, _hoisted_1);
}